<template>
    <div v-if="$store.state.utils.systemMessage.status && $store.state.utils.systemMessage.message" class="systemMessage" :class="'_'+$store.state.utils.systemMessage.status" @click="hide()">
        <p>{{ this.$store.state.utils.systemMessage.message }}</p>
    </div>
</template>

<script>
    export default {
        created () {
          this.hide()
        },
        methods: {
            hide () {
                this.$store.dispatch('utils/hideMessage')
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/assets/style/systemMessage.scss';
</style>
